function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import intlShape from 'shapes/intlShape';
import { isManualReading } from 'helpers/externalDataSources';
import { createReadingsKPIData } from '../../../helpers/kpi';
import messages from '../../../messages';
import styles from './Table.pcss';
var _React_Component;
class Table extends (_React_Component = React.Component) {
    calculateManualReadings(readings) {
        return readings.filter((item)=>isManualReading(item)).length || 0;
    }
    renderEmptyRow(days) {
        const { conversion } = this.props;
        const fixed = conversion.unit === 'MG_DL' ? 0 : 1;
        return /*#__PURE__*/ _jsxs("tr", {
            children: [
                /*#__PURE__*/ _jsx("td", {
                    children: days
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: "0"
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: "0"
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: "0.0"
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: 0..toFixed(fixed)
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: 0..toFixed(fixed)
                }),
                /*#__PURE__*/ _jsxs("td", {
                    children: [
                        0..toFixed(fixed),
                        " - ",
                        0..toFixed(fixed)
                    ]
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: "0.0"
                })
            ]
        });
    }
    renderRow(days, readings) {
        const { conversion, standards } = this.props;
        if (isEmpty(readings)) return this.renderEmptyRow(days);
        const { variability, preMealAverage, strictPostMealAverage } = createReadingsKPIData(readings, conversion, standards);
        const manualReadings = this.calculateManualReadings(readings);
        const automaticReadings = readings.length - manualReadings;
        const readingsPerDay = (readings.length / days).toFixed(1);
        const minValue = conversion.toDisplay(Math.min(...readings.map((reading)=>reading.value)));
        const maxValue = conversion.toDisplay(Math.max(...readings.map((reading)=>reading.value)));
        const fixed = conversion.unit === 'MG_DL' ? 0 : 1;
        return /*#__PURE__*/ _jsxs("tr", {
            children: [
                /*#__PURE__*/ _jsx("td", {
                    children: days
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: automaticReadings || '0'
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: manualReadings || '0'
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: readingsPerDay || '0.0'
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: preMealAverage ? preMealAverage.toFixed(fixed) : '0'
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: strictPostMealAverage ? strictPostMealAverage.toFixed(fixed) : '0'
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: `${(minValue || 0).toFixed(fixed)} - ${(maxValue || 0).toFixed(fixed)}`
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: variability || '0.0'
                })
            ]
        });
    }
    render() {
        const { readings7, readings14, readings30, conversion } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.bloodGlucoseConcenctration__wrapper,
            children: /*#__PURE__*/ _jsx("table", {
                children: /*#__PURE__*/ _jsxs("tbody", {
                    children: [
                        /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: `#${this.props.intl.formatMessage(messages.glucoseReport.tableDays)}`
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: `#${this.props.intl.formatMessage(messages.glucoseReport.tableAutomaticReadings)}`
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: `#${this.props.intl.formatMessage(messages.glucoseReport.tableManualReadings)}`
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: `#${this.props.intl.formatMessage(messages.glucoseReport.tableReadingsPerDay)}`
                                }),
                                /*#__PURE__*/ _jsxs("th", {
                                    children: [
                                        this.props.intl.formatMessage(messages.glucoseReport.tableAveragePreMeal),
                                        ` (${conversion.unitSymbol})`
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("th", {
                                    children: [
                                        this.props.intl.formatMessage(messages.glucoseReport.tableAveragePostMeal),
                                        ` (${conversion.unitSymbol})`
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("th", {
                                    children: [
                                        this.props.intl.formatMessage(messages.glucoseReport.tableRange),
                                        ' ',
                                        `(${conversion.unitSymbol})`
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    className: styles.bold,
                                    children: this.props.intl.formatMessage(messages.glucoseReport.tableVariability)
                                })
                            ]
                        }),
                        this.renderRow(7, readings7),
                        this.renderRow(14, readings14),
                        this.renderRow(30, readings30)
                    ]
                })
            })
        });
    }
}
_define_property(Table, "propTypes", {
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit props
    readings7: PropTypes.array,
    readings14: PropTypes.array,
    readings30: PropTypes.array,
    standards: PropTypes.object,
    conversion: PropTypes.object
});
export default withStyles(styles)(injectIntl(Table));
